// extracted by mini-css-extract-plugin
export default {"buttonCustom":"CustomButton_buttonCustom__6ctRT","leftIcon":"CustomButton_leftIcon__fz7JU","rightIcon":"CustomButton_rightIcon__8ATL2","text":"CustomButton_text__ScdE8"};